import { querySelectorAll, querySelector, querySelectorId } from './querySelectors';
import { THUMB_IMAGE_CLASS, THUMB_ACTIVE_CLASS } from '../scripts/productGallery.js';
import { CHOICE_DATA_CLASS, ORIGINAL_NAME_ATTR, setTotalPrice, setWithoutVatPrice, getPriceBeforeElement, getPriceBefore, METAL_CLASS, METAL_ATTR, MATERIAL_ATTR, METAL_WEIGHT_DEST_CLASS, DISCOUNT_TOP_CLASS, ITEM_DESC_CLASS } from '../functions/productChange';
import customEvent from './customEvent';
import formatPrice from './formatPrice';
import getCurrency from './getCurrency';
import { WEIGHT_SYMBOL, U_DN_CLASS } from '../config/main';
import { MANUAL_CHANGE_EVENT, CHANGE_NAME_EVENT } from './select';
import { EXPRESS_CHECKBOX_CLASS, showExpressOption } from '../scripts/productDetail';
import changeDelivery from './changeDelivery';

const RECHANGE_CLASS = 'js-rechange-select';
const META_PRICE_SELECTOR = 'meta[itemprop="price"]';
const POSITION_ATTR = 'data-choice-pos';
const TYPE_ATTR = 'data-choice-type';
const CHOICE_INPUT_ID = 'choice-id';
const ENGRAVE_SWITCH_CLASS = 'js-engrave-switch';

let productChoices = window.product_choices;

let getSelectors = function() {
  return querySelectorAll(`.${CHOICE_DATA_CLASS}`);
};

let getChoiceData = function() {
  let selectors = getSelectors();
  let list = {};

  selectors.forEach((selector) => {
    if (selector.value === '') {
      return false;
    }

    list[selector.getAttribute(POSITION_ATTR)] = `[${selector.getAttribute(TYPE_ATTR)}=${selector.value}]`;
  });

  return list;
};

let getChoiceIndex = function(choice_data) {
  let out = '';

  for (let key in choice_data) {
    out += choice_data[key];
  }

  return out;
};

let getChoice = function(choice_data) {
  let index = getChoiceIndex(choice_data);
  let choice = productChoices[index];

  if (typeof choice === 'undefined') {
    for (let key in choice_data) {
      let ch = Object.assign({}, choice_data);
      let s = ch[key].split('=');

      if (s[1] === 'ALL]') {
        continue;
      }

      ch[key] = s[0] + '=ALL]';
      index = getChoiceIndex(ch);
      choice = productChoices[index];

      if (typeof choice !== 'undefined') {
        break;
      }
    }
  }

  if (typeof choice === 'undefined') {
    return false;
  }

  return choice;
};

let changePrice = function(price = 0, discount = 0, deliveryId = 0) {
  let metaElement = querySelector(META_PRICE_SELECTOR);

  if (metaElement) {
    metaElement.setAttribute('content', price);
  }

  setTotalPrice(price, deliveryId);

  let priceBeforeElement = getPriceBeforeElement();
  let discountSizeElement = querySelector(`.${DISCOUNT_TOP_CLASS}`);

  if (priceBeforeElement) {
    let price_before = getPriceBefore();

    if (discount !== 0 || discount !== null) {
      price_before = price + discount;
      priceBeforeElement.setAttribute('price', price_before);
      priceBeforeElement.innerHTML = `${formatPrice(price_before)} ${getCurrency()}`;
    }

    if (price_before > price) {
      priceBeforeElement.style.display = 'block';

      if (discountSizeElement) {
        discountSizeElement.style.opacity = 1;
      }
    }
    else {
      priceBeforeElement.style.display = 'none';

      if (discountSizeElement) {
        discountSizeElement.style.opacity = 0;
      }
    }
  }
};

let checkGalleryImage = function(select) {
  if (select.classList.contains(METAL_CLASS)) {
    let activeItem = querySelector(`option[value="${select.options[select.options.selectedIndex].value}"]`, select);

    if (activeItem) {
      if (window.imagesArray.length) {
        let newActive = querySelector(`.${THUMB_IMAGE_CLASS}[${METAL_ATTR}="${activeItem.getAttribute(MATERIAL_ATTR)}"]`);

        if (newActive && !newActive.parentNode.classList.contains(THUMB_ACTIVE_CLASS)) {
          newActive.click();
        }
      }
    }
  }
};

export function productChangeV2(select) {
  if (!select) {
    return;
  }

  if (select.classList.contains(RECHANGE_CLASS)) {
    select.classList.remove(RECHANGE_CLASS);
    checkGalleryImage(select);
    return;
  }

  let selectors = getSelectors();

  if (select.classList.contains(EXPRESS_CHECKBOX_CLASS)) {
    select = selectors[0];
  }

  let actual_choice_pos = select.getAttribute(POSITION_ATTR);
  let choice_data = getChoiceData();

  if (choice_data === false) { // volba nekompletna skonč
    return;
  }

  let choice = getChoice(choice_data);

  if (choice === false) {
    // aktualna volba neexistuje
    // najdi najblizsiu vhodnu pri zachovani hodnoty aktualneho selektoru
    let index = false;
    let val = `[${select.getAttribute(TYPE_ATTR)}=${select.value}]`; // aktualna hodnota selektoru

    for (let key in productChoices) {
      if (key.includes(val) === true) {
        // nasla sa
        choice = productChoices[key];
        index = key;
      }
    }

    if (choice === false) {
      // nenasla sa hladame alternativu pri aktualnej hodnote ako ALL
      val = `[${select.getAttribute(TYPE_ATTR)}=ALL]`;

      for (let key in productChoices) {
        if (key.includes(val) === true) {
          // nasla sa
          choice = productChoices[key];
          index = key;
        }
      }
    }

    if (choice === false) {
      return;
    }

    // prestav ostatne selektory
    selectors.forEach((selector) => {
      let choice_pos = selector.getAttribute(POSITION_ATTR); // pozicia selectoru vo volbe
      let choice_type = selector.getAttribute(TYPE_ATTR); // typ selectoru

      if (actual_choice_pos === choice_pos) {
        return;
      }

      let options = querySelectorAll('option', selector);

      // hladame prislusnu hodnotu selektoru
      let find = false;
      options.forEach((option) => {
        if (find === true) {
          return;
        }

        let value = option.getAttribute('value');
        // cyklus cez kazdu hodnotu selektora
        // je tato hodnota vo volbe ?

        if (index.includes(`[${choice_type}=${value}]`) === true) {
          // je to tato hodnota prestav selektor
          selector.value = value;
          option.selected = 'selected';
          // prejdi na dalsi selektor
          find = true;
        }
      });
    });
  }

  let engrave = false;
  let engraveInput = querySelector(`.${ENGRAVE_SWITCH_CLASS}`);

  if (engraveInput && engraveInput.checked) {
    engrave = true;
  }

  showExpressOption();
  // Volba bola najdena aktualizuj suvisiace data
  querySelectorId(CHOICE_INPUT_ID).value = choice['id']; // vlozime id volby do hidden inputu pre odoslanie na server
  changeDelivery(choice['delivery_id'], choice['pickup'], engrave); // upravime dobu dodania produktu podla dodania najdenej volby
  changePrice(choice['price'], choice['discount'], choice['delivery_id']); // upravime zobrazovanu cenu produktu podla ceny najdenej volby
  setWithoutVatPrice(choice['price_without_vat'], choice['delivery_id']);

  // upravime info o vahe produktu podla vahy najdenej volby
  let metalWeighElement = querySelector(`.${METAL_WEIGHT_DEST_CLASS}`);

  if (metalWeighElement) {
    let metalWrapper = metalWeighElement.closest(`.${ITEM_DESC_CLASS}`);

    if (choice['weight']) {
      metalWeighElement.textContent = `${choice['weight']} ${WEIGHT_SYMBOL}`;
      metalWrapper.classList.remove(U_DN_CLASS);
    }
    else {
      metalWrapper.classList.add(U_DN_CLASS);
    }
  }

  updateSelectors(select);
};

export function updateSelectors(select) {
  let actual_choice_pos = select.getAttribute(POSITION_ATTR);
  let choice_data = getChoiceData();

  if (choice_data === false) { // volba nekompletna skonč
    return;
  }

  let selectors = getSelectors();
  let choice = getChoice(choice_data);

  // Aktualizacia volieb selektorov
  selectors.forEach((selector) => {
    let choice_pos = selector.getAttribute(POSITION_ATTR); // pozicia selectoru vo volbe
    // cyklus cez kazdy selector
    let options = querySelectorAll('option', selector);
    options.forEach((option) => {
      let value = option.getAttribute('value');
      // cyklus cez kazdu hodnotu selektora
      // vymenime atribut vo volbe za tuto hodnotu
      let chd = Object.assign({}, choice_data);

      if (chd[choice_pos]) {
        let s = chd[choice_pos].split('=');
        chd[choice_pos] = s[0] + `=${value}]`;
        // hladame volbu
        let ch = getChoice(chd);
        if (ch !== false) {
          // alternativna volba s touto kombinacoiu existuje
          // zisti cenovu diferenciu
          let diff = ch['price'] - choice['price'];

          if (diff !== 0) {
            diff = `(${formatPrice(diff, true)} ${getCurrency()})`;
          }
          else {
            diff = '';
          }

          option.textContent = `${option.getAttribute(ORIGINAL_NAME_ATTR)} ${diff}`;
          option.disabled = false;
          customEvent(option, CHANGE_NAME_EVENT);
        }
        else if (actual_choice_pos === choice_pos && selector.getAttribute(TYPE_ATTR) !== 'SUP') {
          // u prave voleneho selectoru zobraz vsetky hodnoty
          // aby bola mozna kompletna zmnema volby
          option.textContent = `${option.getAttribute(ORIGINAL_NAME_ATTR)}`;
          option.disabled = false;
          customEvent(option, CHANGE_NAME_EVENT);
        }
        else {
          // volba neexistuje hodnotu skry
          option.disabled = true;
          option.textContent = `${option.getAttribute(ORIGINAL_NAME_ATTR)}`;
          customEvent(option, CHANGE_NAME_EVENT);
        }
      }
    });

    selector.classList.add(RECHANGE_CLASS);
    customEvent(selector, MANUAL_CHANGE_EVENT);
  });
};
